import { slugifyText } from 'logic/slugify-text/slugify-text';

export const BERLIN_CITY_DISTRICTS = [
  'Berlin-Spandau',
  'Berlin-Steglitz',
  'Berlin-Charlottenburg',
  'Berlin-Rheinickendorf',
  'Berlin-Pankow',
  'Berlin-Mitte',
  'Berlin-Tempelhof',
  'Berlin-Neuköln',
  'Berlin-Kreuzberg',
  'Berlin-Lichtenberg',
  'Berlin-Köpernick',
  'Berlin-Marzahn',
  'Berlin-Hellersdorf',
];

export const BERLIN_CITY_DISTRICT_SLUGS = BERLIN_CITY_DISTRICTS.map((district) =>
  slugifyText(district)
);

export const getNearbyPlacesForBerlin = (cityDistrict: string): { place: string }[] => {
  const cityDistrictSlug = slugifyText(cityDistrict);

  const idx = BERLIN_CITY_DISTRICTS.findIndex((i) => slugifyText(i) === cityDistrictSlug);

  const places = [
    ...BERLIN_CITY_DISTRICTS.slice(idx + 1, BERLIN_CITY_DISTRICTS.length),
    ...BERLIN_CITY_DISTRICTS.slice(0, Math.max(idx, 0)),
  ];
  console.log(places);

  return places.slice(0, 10).map((place) => ({ place }));
};
